   
   import { Box } from '@mui/material';
   const AspectRatioBox = ({ ratio }:any) => {
    const getBoxDimensions = (ratio:any) => {
        switch(ratio) {
            case '1:1':
                return { width: 16, height: 16 }; // Square
            case '3:4':
                return { width: 12, height: 16 }; // Portrait
            case '9:16':
                return { width: 9, height: 16 }; // Tall portrait
            case '4:3':
                return { width: 16, height: 12 }; // Landscape
            case '16:9':
                return { width: 20, height: 11 }; // Wide landscape
            default:
                return { width: 16, height: 16 };
        }
    };

    const dimensions = getBoxDimensions(ratio);
    
    return (
        <Box
            sx={{
                width: dimensions.width,
                height: dimensions.height,
                border: '2px solid',
                borderColor: '#ccc',
                backgroundColor: 'transparent',
                borderRadius: '2px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }}
        >
           
        </Box>
    );
};
export default AspectRatioBox;